import React, { Component } from 'react';
import { t } from 'i18next';
import cn from 'classnames';
import { func, number, shape, bool, string, object } from 'prop-types';
import { IonIcon } from '@ionic/react';
import { calendarOutline, locationOutline, timeOutline } from 'ionicons/icons';

import { subsidiaryPropTypes } from '~propTypes/subsidiary';
import { getStoreMapURL } from '~utils/maps';
import { ANALYTICS_CLASSES } from '~constants/analytics';
import SelectTimeDispatch from '~screens/Dashboard/components/SelectTimeDispatch';

import styles from './styles.module.scss';

class Store extends Component {
  handleSelect = () => {
    const { onSelect, store } = this.props;

    onSelect(store);
  };

  handleMouseEnter = () => {
    const { onMouseEnter, store } = this.props;

    onMouseEnter(store);
  };

  handleMouseLeave = () => {
    const { onMouseLeave, store } = this.props;

    onMouseLeave(store);
  };

  render() {
    const { store, order, location, focused, selectedStore, onSelectedTime, selectedTime, setScheduled } =
      this.props;
    const isHotspot = store?.hotspot;
    const isPapaCar = store?.papacar;
    const waitTime = isHotspot && !isPapaCar ? store.deliveryWaitTime : store.pickUpWaitTime;

    return (
      <button
        type="button"
        onClick={this.handleSelect}
        key={store.id}
        className={cn('full-width', styles.card, {
          [styles.current]: focused,
          [styles.isHotspot]: store.hotspot && !store?.papacar
        })}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}>
        <div className="row stretch full-width">
          <div className={`row full-width ${styles.storeInfo}`}>
            <div className={`column start ${styles.infoTexts}`}>
              <h5
                className={`subtitle-small m-bottom-1 text-boulder full-width text-truncate ${styles.storeName}`}>
                {`${order}. ${store.name}`}
              </h5>

              {store?.papacar && (
                <span className={`${styles.hotspotIndicator} text-dusty-gray m-bottom-1`}>
                  {t('DeliveryOrPickUp:hotspotPapaCar')}
                </span>
              )}

              {store.hotspot && !store?.papacar && (
                <span className={`${styles.hotspotIndicator} text-dusty-gray m-bottom-1`}>
                  {t('DeliveryOrPickUp:hotspotPickup')}
                </span>
              )}

              <span className={`text-base m-bottom-1 full-width ${styles.storeAddress}`}>
                {store.textAddress}
              </span>
              <span className={`row middle text-base text-emperor ${styles.fullMaxWidth}`}>
                {store.pickUpOpen ? (
                  <>
                    <IonIcon className={`m-right-1 ${styles.waitTimeIcon}`} icon={timeOutline} />
                    <span className={`${styles.time} text-truncate`}>
                      {t('DeliveryOrPickUp:readyIn')} {waitTime} {t('DeliveryOrPickUp:minAprox')}
                    </span>
                  </>
                ) : (
                  <>
                    <IonIcon className={`m-right-1 ${styles.calendarIcon}`} icon={calendarOutline} />
                    <span className={`${styles.scheduleTime} text-truncate`}>
                      {t('DeliveryOrPickUp:scheduleOrder')}
                    </span>
                  </>
                )}
              </span>
            </div>
          </div>
          <div className={`row center middle ${styles.mapLinkContainer}`}>
            <a
              className={`row link ${styles.mapLink} ${ANALYTICS_CLASSES.links.stores.indications}`}
              href={getStoreMapURL(location, store)}
              target="blank"
              aria-label={t('DeliveryOrPickUp:seeMap')}>
              <IonIcon className={`m-right-1 ${styles.icon}`} icon={locationOutline} />
              <span className={styles.linkText}>{t('DeliveryOrPickUp:seeMap')}</span>
            </a>
          </div>
        </div>
        {selectedStore ? (
          <div
            className={cn(styles.selectTimeContainer, {
              [styles.disabled]: selectedStore.name !== store.name
            })}>
            <SelectTimeDispatch
              pickUp
              selectedStore={selectedStore}
              onSelectedTime={onSelectedTime}
              selectedDeliveryTime={selectedTime}
              setScheduled={setScheduled}
            />
          </div>
        ) : null}
      </button>
    );
  }
}

Store.propTypes = {
  location: shape({
    lat: number,
    lng: number
  }).isRequired,
  order: number.isRequired,
  store: subsidiaryPropTypes.isRequired,
  onMouseEnter: func.isRequired,
  onMouseLeave: func.isRequired,
  onSelect: func.isRequired,
  focused: bool,
  selectedStore: string,
  selectedTime: object,
  setScheduled: func,
  onSelectedTime: func
};

export default Store;
